module.exports = "#Vendor {\n  text-size: 20px;\n}\n/*# sourceMappingURL=src/app/vendor/vendor.app.component.css.map */"